import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/mobile/footer_logo.png'


const _withScopeId = n => (_pushScopeId("data-v-21255e46"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "page_footer" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  id: "img",
  src: _imports_0
}, null, -1))
const _hoisted_3 = { id: "footer_text_content" }
const _hoisted_4 = { id: "text_content" }
const _hoisted_5 = {
  href: "https://beian.miit.gov.cn/",
  id: "text_content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, _toDisplayString($data.copyright), 1),
      _createElementVNode("a", _hoisted_5, _toDisplayString($data.address), 1)
    ])
  ]))
}